import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import _ from 'lodash';
import React from 'react';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import { useConfirm } from 'material-ui-confirm';
import { useTranslation } from 'react-i18next';

const CustomDialog = ({
  icon,
  iconAction,
  open,
  onClose,
  title,
  subtitle,
  children,
  maxWidth,
  actions,
  resetToDefaultHandler,
  hasDefaultValuesSelector,
  openDefaultValueSelector,
  noHeader,
  endIcon,
  endIconAction,
  ...props
}) => {
  const confirm = useConfirm();
  const { t } = useTranslation();

  const resetToDefaultConfirm = () => {
    confirm({
      title: t('set.default.value.title.confirmation'),
      description: t('set.default.value.body.confirmation'),
    }).then(async () => {
      resetToDefaultHandler();
    });
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={maxWidth || 'xs'}
      fullWidth
      sx={(theme) => ({
        ...(theme.palette.mode === 'dark' && {
          scrollbarColor: `${theme.palette.grey[700]} transparent`,
        }),
        ...props?.sx,
      })}
      {...props}
    >
      {!noHeader && (
        <Stack
          spacing={0}
          direction="row"
          alignItems="center"
          sx={{ pt: 3, mx: 3 }}
          columnGap={1}
        >
          {!_.isEmpty(icon) && (
            <IconButton color="primary" component="span" onClick={iconAction}>
              {icon}
            </IconButton>
          )}
          <DialogTitle sx={{ p: 0, flexGrow: 1 }}>{title}</DialogTitle>
          {hasDefaultValuesSelector && (
            <Button
              color="primary"
              component="span"
              onClick={openDefaultValueSelector}
            >
              <YoutubeSearchedForIcon />
            </Button>
          )}
          {endIcon && (
            <IconButton
              color="primary"
              component="span"
              onClick={endIconAction}
              sx={{ ml: 1 }}
            >
              {endIcon}
            </IconButton>
          )}
        </Stack>
      )}
      <DialogContent sx={!_.isEmpty(subtitle) ? { pt: 0 } : {}}>
        {subtitle && <DialogContentText>{subtitle}</DialogContentText>}
        {children}
      </DialogContent>
      {(actions || resetToDefaultHandler) && (
        <DialogActions sx={{ p: 0, m: 0 }}>
          {resetToDefaultHandler && (
            <Button
              color="primary"
              component="span"
              onClick={resetToDefaultConfirm}
              sx={{ mr: 2 }}
            >
              <SettingsBackupRestoreIcon />
            </Button>
          )}
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomDialog;
